<template>
  <navBar
    current="about"
    @change="if ($event == 'about') swiper.slideTo(0);"
  ></navBar>

  <swiper
    :class="['about-swiper full-screen']"
    :simulateTouch="false"
    :freeMode="screenWidth <= 1200"
    direction="vertical"
    :mousewheel="screenWidth <= 1200 ? { sensitivity: 5 } : true"
    :pagination="{ clickable: true, bulletClass: 'about-swiper-bullet' }"
    @slideChange="swiperIndex = $event.activeIndex"
    @swiper="swiper = $event"
  >
    <swiper-slide><section-1 /></swiper-slide>
    <swiper-slide><section-2 /></swiper-slide>
    <swiper-slide><section-3 /></swiper-slide>
    <swiper-slide><section-4 /></swiper-slide>
  </swiper>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import navBar from "../../components/nav-bar/nav-bar.vue";
import ABOUT_SECTION_COMPONENTS from "./section-components";

import { Swiper, SwiperSlide } from "swiper/vue";
import SwiperCore, { Mousewheel, Pagination } from "swiper";
require("swiper/swiper.less");
require("swiper/components/pagination/pagination.less");

const SWIPER_COMPONENTS = {
  Swiper,
  SwiperSlide,
};

SwiperCore.use([Pagination, Mousewheel]);
export default defineComponent({
  components: {
    navBar,
    ...SWIPER_COMPONENTS,
    ...ABOUT_SECTION_COMPONENTS,
  },

  data() {
    return {
      swiper: null,
      swiperIndex: 0,
      screenWidth: document.body.clientWidth,
    };
  },

  mounted() {
    window.onresize = () => {
      let width = document.body.clientWidth;
      if ((this.screenWidth <= 1024 && width > 1024) || (this.screenWidth > 1024 && width <= 1024)) {
        location.reload();
      }
      this.screenWidth = width;
    };
  },
});
</script>

<style lang="less" scoped>
.about-swiper {
  /deep/.swiper-wrapper {
    transition-duration: 0.3s !important;
  }

  /deep/.swiper-pagination {
    right: 1.88vw;

    .about-swiper-bullet {
      display: block;
      @hr: 0.52vw;
      width: @hr;
      height: @hr;
      background: @color-primary;
      opacity: 0.2;
      border-radius: 50%;
      margin: 0 0 10px 0;
      cursor: pointer;
      transition: opacity 0.1s ease;

      &.swiper-pagination-bullet-active {
        opacity: 1;
      }
    }
  }
}

@media screen and(max-width:1200px) {
  .about-swiper > .swiper-wrapper {
    transition-duration: 0.3s !important;

    > .swiper-slide {
      max-height: 50vw;
    }
  }
}
</style>